import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex gap-2 mb-3" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "date",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.localStatusDate) = $event)),
      class: "w-1/2 text-xs border border-gray-200 rounded-md px-2 py-1.5 focus:outline-none focus:border-brand-400 focus:ring-0 bg-white"
    }, null, 512), [
      [_vModelText, $setup.localStatusDate]
    ]),
    _createElementVNode("select", {
      value: $props.currentStatus,
      class: "w-1/2 text-xs border border-gray-200 rounded-md px-2 py-1.5 focus:outline-none focus:border-brand-400 focus:ring-0 bg-white",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleStatusChange && $setup.handleStatusChange(...args)))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("option", { value: "" }, "Add Status", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.statuses, (status) => {
        return (_openBlock(), _createElementBlock("option", {
          key: status,
          value: status
        }, _toDisplayString(status), 9, _hoisted_3))
      }), 128))
    ], 40, _hoisted_2)
  ]))
}